import type {
  StartTutorialOptions,
  Tutorial,
  TutorialOverlayProps,
  TutorialTargetRegistrations,
} from 'app/types/tutorial';
import type { Signal } from 'app/network/signals';
import { getDefaultStore } from 'jotai';
import { atomWithReset, useResetAtom } from 'jotai/utils';

export const presentTutorialOverlayAtom = atomWithReset<TutorialOverlayProps | undefined>(undefined);
export const hideTutorialOverlayAtom = atomWithReset<boolean>(false);
export const currentTutorialAtom = atomWithReset<Tutorial | undefined>(undefined);
export const currentTutorialStartOptionsAtom = atomWithReset<StartTutorialOptions | undefined>(undefined);
export const currentTutorialStepAtom = atomWithReset<number>(0);
export const postponedSignalsAtom = atomWithReset<Signal[]>([]);
export const chatTutorialVariantAtom = atomWithReset<'offer' | 'request' | undefined>(undefined);
export const tutorialTargetRegistrationsAtom = atomWithReset<TutorialTargetRegistrations>({});

export function getCurrentTutorial() {
  return getDefaultStore().get(currentTutorialAtom);
}

export function useResetTutorialsAtoms() {
  const resetPresentTutorialOverlay = useResetAtom(presentTutorialOverlayAtom);
  const resetHideTutorialOverlay = useResetAtom(hideTutorialOverlayAtom);
  const resetCurrentTutorial = useResetAtom(currentTutorialAtom);
  const resetCurrentTutorialStartOptions = useResetAtom(currentTutorialStartOptionsAtom);
  const resetCurrentTutorialStep = useResetAtom(currentTutorialStepAtom);
  const resetPostponedSignals = useResetAtom(postponedSignalsAtom);
  const resetChatTutorialVariant = useResetAtom(chatTutorialVariantAtom);
  const resetTutorialTargetRegistrations = useResetAtom(tutorialTargetRegistrationsAtom);
  return () => {
    resetPresentTutorialOverlay();
    resetHideTutorialOverlay();
    resetCurrentTutorial();
    resetCurrentTutorialStartOptions();
    resetCurrentTutorialStep();
    resetPostponedSignals();
    resetChatTutorialVariant();
    resetTutorialTargetRegistrations();
  };
}
